import { DIMENSIONS, DIMENSION_KEYS } from '../surveys/dimensions.js'
import { MOTIVATORS, DEMOTIVATORS } from '../surveys/miway-4.js'

const PRIO_WEIGHT = { 1: 2, 2: 1 }

// Berechnet Wertedimensions-Profil
// Eingabe: response.data wie in surveyStore strukturiert
// Ausgabe: { violet: { score, motivPct, demoPct, motivDefs[], demoDefs[] }, ... }
export function computeProfile(data) {
  const dims = Object.fromEntries(
    DIMENSION_KEYS.map(k => [k, {
      ...DIMENSIONS[k],
      motivPoints: 0,
      demoPoints: 0,
      motivDefs: [], // [{word, defText, prio}]
      demoDefs: [],
    }])
  )

  const motivDefsByLabel = Object.fromEntries(MOTIVATORS.map(m => [m.label, m.defs]))
  const demoDefsByLabel = Object.fromEntries(DEMOTIVATORS.map(m => [m.label, m.defs]))

  for (const [word, prios] of Object.entries(data.motivators?.definitions || {})) {
    const defs = motivDefsByLabel[word] || []
    prios.forEach((defIdx, i) => {
      if (defIdx == null) return
      const def = defs[defIdx]
      if (!def) return
      const prio = i + 1
      const weight = PRIO_WEIGHT[prio] || 0
      const dim = dims[def.dim]
      if (!dim) return
      dim.motivPoints += weight
      dim.motivDefs.push({ word, defText: def.text, prio })
    })
  }
  for (const [word, prios] of Object.entries(data.demotivators?.definitions || {})) {
    const defs = demoDefsByLabel[word] || []
    prios.forEach((defIdx, i) => {
      if (defIdx == null) return
      const def = defs[defIdx]
      if (!def) return
      const prio = i + 1
      const weight = PRIO_WEIGHT[prio] || 0
      const dim = dims[def.dim]
      if (!dim) return
      dim.demoPoints += weight
      dim.demoDefs.push({ word, defText: def.text, prio })
    })
  }

  // Maximalwert pro Dimension wenn alle 10 Motivatoren / 10 Demotivatoren in einer Dim landen:
  // 10 × (Prio1 = 2 + Prio2 = 1) = 30 Punkte → entspricht 100%
  // Aber das Original-Diagramm skaliert auf -25%/+25% relativ zum individuellen Maximum.
  // Wir liefern absolute Prozent (0–100) und überlassen dem Chart die Skalierung.
  const MAX = 30
  const totalMotiv = Object.values(dims).reduce((s, d) => s + d.motivPoints, 0) || 1
  const totalDemo = Object.values(dims).reduce((s, d) => s + d.demoPoints, 0) || 1
  for (const k of DIMENSION_KEYS) {
    const d = dims[k]
    d.motivPct = Math.round((d.motivPoints / totalMotiv) * 100) || 0
    d.demoPct = Math.round((d.demoPoints / totalDemo) * 100) || 0
    // Für das Diagramm normalisieren wir auf maximale individuelle Auslenkung
    d.motivShare = d.motivPoints / MAX
    d.demoShare = d.demoPoints / MAX
  }

  // Top-Dimensionen
  const sortedMotiv = DIMENSION_KEYS
    .map(k => dims[k])
    .filter(d => d.motivPoints > 0)
    .sort((a, b) => b.motivPoints - a.motivPoints)
  const sortedDemo = DIMENSION_KEYS
    .map(k => dims[k])
    .filter(d => d.demoPoints > 0)
    .sort((a, b) => b.demoPoints - a.demoPoints)

  return { dims, sortedMotiv, sortedDemo }
}
